/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Save_Mock_1Inputs */

const en_cap_save_mock_1 = /** @type {(inputs: Cap_Save_Mock_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturday availability and price?`)
};

const lv_cap_save_mock_1 = /** @type {(inputs: Cap_Save_Mock_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai sestdien ir brīvs laiks un cik maksā?`)
};

/**
* | output |
* | --- |
* | "Saturday availability and price?" |
*
* @param {Cap_Save_Mock_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_save_mock_1 = /** @type {((inputs?: Cap_Save_Mock_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Save_Mock_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_save_mock_1(inputs)
	return en_cap_save_mock_1(inputs)
});